import { render } from "./Auswertungen.vue?vue&type=template&id=d20a866c"
import script from "./Auswertungen.vue?vue&type=script&lang=js"
export * from "./Auswertungen.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__